import { useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'
import { getBonusConfiguration } from './getBonusConfiguration'
import { BonusConfigurationModel } from '@/app/models/timesheet/bonusConfigurationModel'
import { BonusConfigurationQueryInput } from './types'

export function useBonusConfigurationQuery(
  props: BonusConfigurationQueryInput & {
    disabled?: boolean
  },
) {
  return useQuery<BonusConfigurationModel>({
    queryKey: [
      'bonus-configuration',
      props.companyId,
      props.payload.companyId,
      props.payload.driverId,
      props.payload.month,
      props.payload.year,
    ],
    queryFn: async () => {
      const { data } = await getBonusConfiguration(props)
      return data
    },
    enabled:
      !props.disabled &&
      !!props.companyId &&
      !!props.payload.companyId &&
      !!props.payload.driverId &&
      props.payload.month !== undefined &&
      props.payload.month !== null &&
      props.payload.year !== undefined &&
      props.payload.year !== null,
    staleTime: MINUTE_IN_MS * 5, // cache for 5 minutes
  })
}
